// extracted by mini-css-extract-plugin
export default {"actionItem":"DefinitionDangerZone-module__actionItem__n1P0evs","divider":"DefinitionDangerZone-module__divider__Gd9gaed"};